export class Debouncer {
  timeoutId: NodeJS.Timer;
  debouncer: () => void;

  constructor(f: () => void, wait: number = 50) {
    this.debouncer = () => {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(f, wait);
    };
  }

  go() {
    this.debouncer();
  }

  cancel() {
    clearTimeout(this.timeoutId);
  }
}



// WEBPACK FOOTER //
// ./src/debouncer.tsx